<template>
  <div class="teacher-intro">
    <Titles class="intro-title" :title="data.title" />
    <div class="subTitle font-medium">
      {{ data.description }}
    </div>
    <div class="intro-box">
      <div class="list-wrapper">
        <div
          v-for="(item, index) in data.teacherList"
          :key="index"
          class="teacher-item"
        >
          <nuxt-link :to="'/teachers/detail/'+item.id">
            <TeacherInfo :teacher="item" :index="index + 1" :show-experience="true" />
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import TeacherInfo from 'components/common/TeacherInfo/index.vue'
import Titles from 'components/courses/UkCourseTitle'
import { oneApi } from 'config/api'
import { isInView } from 'common/utils';

export default {
  components: { Titles, TeacherInfo },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      teacherList: [],
    }
  },
  watch: {
    data: {
      handler(val) {
        if (val.teacherIds && val.teacherIds.length > 0) { this.getTeacherList(); }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
  },
  methods: {
    async getTeacherList() {
      const res = await this.$axios.post(oneApi.queryTeacherBanner, this.data.teacherIds, { rewritePostBody: true });
      this.teacherList = res.data
    },
    pageScrollHandler() {
      this.teacherList.forEach((item) => {
        /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["item"] }] */
        if (isInView(`teacherCard${item.teacherId}`)) {
          if (!item.show) {
            item.show = true // 已经显示过了就不要再重复埋点
            this.Sensors.track('grade_page_teachercard_pv', {
              grade_name: this.$route.query.name,
              subject: item.subjects ? item.subjects.join(',') : '',
              teacher_name: item.name,
              teacher_id: item.teacherId,
            })
          }
        } else {
          // 如果不在屏幕内则改成false
          item.show = false
        }
      })
    },
  },
}

</script>
<style lang="scss" scoped>
.teacher-intro {
  width: 1240px;
  margin: 0 auto 30px auto;

  .intro-title {
    margin-bottom: 5px;
  }

  .subTitle {
    font-size: 20px;
    padding-left: 18px;
    color: var(--txt-color-lv3);
    line-height: 34px;
  }

  .intro-box {
    display: flex;
    margin: 0 -10px;
    flex-wrap: wrap;
    overflow: auto;

    .list-wrapper {
      display: flex;
      height: fit-content;

      .teacher-item {
        height: 358px;
        overflow: visible;
      }

      // /deep/.teacher-info {
      //   height: auto;
      // }
    }
  }
}
</style>
